import Button from "../../components/Shared/Button"
import TeamMemberCard from "../../components/Dashboard/Instructors/TeamMemberCard"
import AddIcon from "../../components/Icons/AddIcon"
import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import AddNewMember from "../../components/Dashboard/Instructors/AddNewMember"
import { GetAllInstructors } from "../../api/Instructor/GetAllInstructors"
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton"
const Instructors = () => {
    const [showAddMember, setShowAddMember] = useState(false);
    const { data: InstructorDTO } = useQuery({
        queryFn: GetAllInstructors,
        queryKey: ["instructors"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const handleAddMemberSuccess = () => {
        setShowAddMember(false);
      };
    
    const instructors = InstructorDTO?.data
    return (
        <div>
            {showAddMember ? (
                <div className="space-y-4">
                    <DashboardInlineBackButton
                        label="Back to instructors"
                        onClick={() => setShowAddMember(false)}
                    />
                    <AddNewMember onSuccess={handleAddMemberSuccess} />
                </div>
            ) : (

                <div>
                    <div className="flex justify-between items-center py-7">
                        <h1 className="text-burntBlack font-bold text-[32px]">Instructors</h1>
                        <Button
                            onClick={() => setShowAddMember(true)}
                            className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                            variant="primary"
                        >
                            <AddIcon className="mr-1.5" />
                            Add New Instructor
                        </Button>
                    </div>
                    <div className="grid grid-cols-4 gap-7">
                        {instructors?.map((Instructor) => (
                            <TeamMemberCard instructorId={Instructor.id} img={Instructor.photo} title="Instructor" name={`${Instructor.firstName } ${Instructor.lastName}`} email={Instructor.email} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Instructors
